import React from "react";
import useDynamicStyle from "./hooks/useDynamicStyle";
import useTruncateContent from "./hooks/useTruncateContent";
import { BaseButton, BaseContainer, BaseInner } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TruncateContent(_ref) {
  var children = _ref.children,
    _ref$gradientColor = _ref.gradientColor,
    gradientColor = _ref$gradientColor === void 0 ? "$neutral1" : _ref$gradientColor,
    _ref$initialHeight = _ref.initialHeight,
    initialHeight = _ref$initialHeight === void 0 ? "75px" : _ref$initialHeight,
    _ref$buttonTextColor = _ref.buttonTextColor,
    buttonTextColor = _ref$buttonTextColor === void 0 ? "$neutral11" : _ref$buttonTextColor;
  var _useTruncateContent = useTruncateContent(),
    isTruncated = _useTruncateContent.isTruncated,
    toggleTruncated = _useTruncateContent.toggleTruncated;
  var dynamicStyle = useDynamicStyle(gradientColor, initialHeight);
  return /*#__PURE__*/_jsxs(BaseContainer, {
    children: [/*#__PURE__*/_jsx(BaseInner, {
      css: dynamicStyle,
      truncated: isTruncated,
      children: children
    }), /*#__PURE__*/_jsx(BaseButton, {
      type: "button",
      css: {
        color: buttonTextColor
      },
      onClick: toggleTruncated,
      children: isTruncated ? "Show more" : "Show less"
    })]
  });
}
export default TruncateContent;